/**
 * Input de Staff (design-system §7 · Input y §8.1): fondo superficie, borde `--fm-border`, radio
 * md, altura 48 px, padding 12 px y texto de **16 px** (evita el zoom automático de iOS, §10).
 * Foco: borde coral y anillo visible. Estado inválido: borde `--fm-danger`.
 */
import { cn } from './cn';

import type { InputHTMLAttributes, Ref } from 'react';

export const INPUT_CLASSES =
  'w-full rounded-fm-md border border-fm-border bg-fm-surface px-fm-3 text-fm-base text-fm-text ' +
  'placeholder:text-fm-text-disabled transition-colors duration-fm-fast ease-fm-standard ' +
  'focus:border-fm-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fm-focus ' +
  'aria-[invalid=true]:border-fm-danger disabled:opacity-45 disabled:cursor-not-allowed ' +
  'motion-reduce:transition-none';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export function Input({ className, invalid, ...props }: InputProps) {
  return (
    <input
      className={cn(INPUT_CLASSES, 'h-fm-control-md', className)}
      aria-invalid={invalid ? true : undefined}
      {...props}
    />
  );
}
